import type { components } from '../../api-types';
import type { SoftwareRelease } from '$lib/types/softwareRelease';
import { parseDateTime } from '$lib/mappers/dates';

export type ApiSoftwareRelease = components['schemas']['SoftwareRelease'];

export function mapApiSoftwareReleaseToSoftwareRelease(api: ApiSoftwareRelease): SoftwareRelease {
  try {
    return {
      id: api.id,
      version: api.version,
      createdAt: parseDateTime(api.createdAt),
      removedAt: api.removedAt ? parseDateTime(api.removedAt) : null
    };
  } catch (error) {
    console.error('Error mapping software release:', error, api);
    throw new Error(
      `Failed to map software release: ${error instanceof Error ? error.message : 'Unknown error'}`,
      { cause: error }
    );
  }
}

export function mapApiSoftwareReleasesToSoftwareReleases(
  apiSoftwareReleases: ApiSoftwareRelease[]
): SoftwareRelease[] {
  return apiSoftwareReleases.map(mapApiSoftwareReleaseToSoftwareRelease);
}
